import { render, staticRenderFns } from "./MyCollection.vue?vue&type=template&id=dab4a1ce&scoped=true&"
import script from "./MyCollection.vue?vue&type=script&lang=js&"
export * from "./MyCollection.vue?vue&type=script&lang=js&"
import style0 from "./MyCollection.vue?vue&type=style&index=0&id=dab4a1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab4a1ce",
  null
  
)

export default component.exports